import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section
      id="inicio"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* BACKGROUND */}
      <div className="absolute inset-0 w-full h-full overflow-hidden">
        {/* HERO IMAGE */}
        <img
          src="/images/hero/hero-industrial-hse.webp"
          alt="SafeLine Solutions"
          loading="eager"
          fetchPriority="high"
          width={1920}
          height={1080}
          className="
            w-full
            h-full
            object-cover
            object-center
            brightness-[0.68]
            saturate-[1.05]
            contrast-[0.88]
            hue-rotate-[8deg]
            blur-[1px]
            scale-[1.02]
          "
        />

        {/* BASE DARK OVERLAY */}
        <div className="absolute inset-0 bg-[#07111A]/60"></div>

        {/* CINEMATIC TEAL/NAVY GRADIENT */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#07111A]/88 via-[#0F4C5C]/65 to-[#07111A]/40"></div>

        {/* TEAL ATMOSPHERIC GLOW */}
        <div className="absolute inset-0 bg-teal-500/15 mix-blend-soft-light"></div>

        {/* SUBTLE VIGNETTE */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#07111A]/55 via-transparent to-[#07111A]/30"></div>
      </div>

      {/* CONTENT */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-32 text-center w-full">
        {/* BADGE */}
        <div className="inline-block bg-white/10 backdrop-blur-sm border border-white/20 text-white px-5 py-2.5 rounded-full text-sm font-semibold mb-8">
          Servicios HSE, acreditación y cumplimiento
        </div>

        {/* TITLE */}
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Soluciones HSE <br />

          <span className="text-teal-400">
            Prácticas y Efectivas
          </span>
        </h1>

        {/* DESCRIPTION */}
        <p className="text-xl md:text-2xl text-white/90 mb-12 max-w-3xl mx-auto leading-relaxed">
          Ordenamos, verificamos y acompañamos tu operación para que
          cumplas normativa y operes con total continuidad.
        </p>

        {/* CTA BUTTONS */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          {/* BUTTON 1 */}
          <Link
            to="/contacto"
            className="
              bg-white/10
              backdrop-blur-sm
              border-2
              border-white/30
              text-white
              px-8
              py-4
              rounded-lg
              text-base
              font-semibold
              hover:bg-white/20
              transition-all
              inline-flex
              items-center
              gap-2
              whitespace-nowrap
              focus-visible:outline
              focus-visible:outline-2
              focus-visible:outline-offset-2
              focus-visible:outline-teal-300
            "
          >
            Solicitar contacto

            <i className="ri-arrow-right-line text-xl"></i>
          </Link>

          {/* BUTTON 2 */}
          <Link
            to="/servicios"
            className="
              relative
              bg-teal-400
              text-gray-900
              px-10
              py-4
              rounded-lg
              text-base
              font-bold
              hover:bg-teal-300
              transition-all
              inline-flex
              items-center
              gap-2
              whitespace-nowrap
              shadow-lg
              shadow-teal-400/40
              hover:shadow-teal-300/50
              hover:scale-105
              focus-visible:outline
              focus-visible:outline-2
              focus-visible:outline-offset-2
              focus-visible:outline-white
              group
            "
          >
            <i className="ri-layout-grid-line text-xl"></i>

            Ver todos los servicios

            <i className="ri-arrow-right-line text-xl transition-transform group-hover:translate-x-1"></i>
          </Link>
        </div>

        {/* STATS */}
        <div className="mt-20 grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {/* CARD 1 */}
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6">
            <div className="w-14 h-14 bg-teal-500/20 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-time-line text-3xl text-teal-400"></i>
            </div>

            <h3 className="text-lg font-bold text-white mb-2">
              Reducción de Tiempos
            </h3>

            <p className="text-white/80 text-sm">
              Acreditación rápida y sin rechazos
            </p>
          </div>

          {/* CARD 2 */}
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6">
            <div className="w-14 h-14 bg-teal-500/20 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-3xl text-teal-400"></i>
            </div>

            <h3 className="text-lg font-bold text-white mb-2">
              Cumplimiento Legal
            </h3>

            <p className="text-white/80 text-sm">
              Aseguramos el mínimo normativo
            </p>
          </div>

          {/* CARD 3 */}
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl p-6">
            <div className="w-14 h-14 bg-teal-500/20 rounded-lg flex items-center justify-center mx-auto mb-4">
              <i className="ri-user-settings-line text-3xl text-teal-400"></i>
            </div>

            <h3 className="text-lg font-bold text-white mb-2">
              Acompañamiento
            </h3>

            <p className="text-white/80 text-sm">
              Presencia en terreno cuando lo necesitas
            </p>
          </div>
        </div>
      </div>
    </section>
  );
  }